<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    direction="ltr"
    size="600px"
  >
    <el-form label-position="top" size="small" style="margin: 10px">
      <el-row :gutter="10">
        <el-col :span="12">
          <!-- 处理结果 -->
          <el-form-item :label="$t('collectionCenter.processingResult')">
            <el-select
              v-model="searchParams.handlingResult"
              :placeholder="$t('collectionCenter.pleaseChoose')" clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in processResultList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 处理大区 -->
          <el-form-item :label="$t('collectionCenter.processingRegion')">
            <el-select
              v-model="searchParams.handlingRegionList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              style="width: 100%" collapse-tags
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 处理网点 -->
          <el-form-item :label="$t('collectionCenter.processingBranch')">
            <el-select
              v-model="searchParams.handlingSiteList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              style="width: 100%" collapse-tags
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 上报大区 -->
          <el-form-item :label="$t('fixDutyFine.reportingRegion')">
            <el-select
              v-model="searchParams.reportRegionList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              style="width: 100%" collapse-tags
            >
              <el-option
                v-for="item in regionList2"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 上报网点 -->
          <el-form-item :label="$t('collectionCenter.reportingBranch')">
            <el-select
              v-model="searchParams.reportSiteList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              style="width: 100%" collapse-tags
            >
              <el-option
                v-for="item in siteList2"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 登记来源 -->
          <el-form-item :label="$t('collectionCenter.registrationSource')">
            <el-select
              v-model="searchParams.registrationSource"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              style="width: 100%"
              @change="changeSource"
            >
              <!--  0 快递系统     1 服务商系统  -->
              <el-option :label="$t('customerManagements.expressSystem')" :value="0" />
              <el-option :label="$t('customerManagements.providerSystem')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 登记人 -->
          <el-form-item :label="$t('collectionCenter.registrar')">
            <el-select
              v-model="searchParams.registrationUserList"
              :placeholder="
                searchParams.registrationSource === '' || searchParams.registrationSource === null
                  ? $t('collectionCenter.selectRegistrationSource') : $t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              style="width: 100%"
              remote reserve-keyword :remote-method="getRegister"
              :disabled="searchParams.registrationSource === '' || searchParams.registrationSource === null"
            >
              <el-option
                v-for="item in registerList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 结束操作人 -->
          <el-form-item :label="$t('collectionCenter.endOperator')">
            <el-select
              v-model="searchParams.endOperationPersonList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable filterable multiple
              remote reserve-keyword :remote-method="getRegistrationUserList"
              style="width: 100%"
            >
              <el-option
                v-for="item in registrationList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <!--搜索-->
          <el-button
            size="small" type="primary" @click="clickSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            size="small" type="info" @click="resetForm"
          >{{ $t('newOrder.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-drawer>
</template>

<script>
import {
  regionQueryList,
  selectInfoByStateTwo
} from '@/api/orderApi';
import { getUserPage } from '@/api/user';
import {
  getdelivererList
} from '@/api/newExpressAPI';
export default {
  data() {
    return {
      searchDrawer: false,
      searchParams: {
        handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
        handlingRegionList: [], // 处理大区
        handlingSiteList: [], // 处理网点
        reportRegionList: [], // 上报大区
        reportSiteList: [], // 上报网点
        registrationUserList: [], // 登记人
        endOperationPersonList: [], // 结束操作人
        registrationSource: null // 登记来源,0快递系统,1服务商系统
      },
      processResultList: [
        { id: null, name: this.$t('collectionCenter.tudo') }, // 全部
        { id: 1, name: this.$t('collectionCenter.upstreamResponsibility') }, // 上游责任
        { id: 2, name: this.$t('collectionCenter.downstreamResponsibility') }, // 下游责任
        { id: 5, name: this.$t('collectionCenter.partialResponsibility') }, // 部分责任
        { id: 3, name: this.$t('GlobalSetObj.blameless') }, // 无责
        { id: 4, name: this.$t('home.moreTimeNotReply') } // 超时未回复
      ],
      regionList: [],
      siteList: [],
      regionList2: [],
      siteList2: [],
      registrationList: [],
      registerList: [] // 登记人
    };
  },
  watch: {
    'searchParams.handlingRegionList'(val) {
      // 大区为多选，展示大区下所有网点
      this.searchParams.handlingSiteList = [];
      if (val.length === 0) {
        this.getSiteList();
        return;
      }
      const allSites = [];
      val.forEach(regionId => {
        const selectedRegion = this.regionList.find((item) => item.id === regionId);
        if (selectedRegion && selectedRegion.sites) {
          allSites.push(...selectedRegion.sites);
        }
      });
      this.siteList = allSites;
    },
    'searchParams.reportRegionList'(val) {
      this.searchParams.reportSiteList = [];
      if (val.length === 0) {
        this.getSiteList();
        return;
      }
      const allSites = [];
      val.forEach(regionId => {
        const selectedRegion = this.regionList2.find((item) => item.id === regionId);
        if (selectedRegion && selectedRegion.sites) {
          allSites.push(...selectedRegion.sites);
        }
      });
      this.siteList2 = allSites;
    }
  },
  mounted() {
    this.getRegion();
    this.getSiteList();
    this.getRegistrationUserList('');
    this.getRegistrationUserList2('');
  },
  methods: {
    showDialog() {
      this.searchDrawer = true;
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
          this.regionList2 = res.data;
        }
      });
    },
    // 网点
    getSiteList() {
      const data = {};
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            if (!this.searchParams.handlingRegionList || this.searchParams.handlingRegionList.length <= 0) {
              this.siteList = res.data.siteList;
            }
            if (!this.searchParams.reportRegionList || this.searchParams.reportRegionList.length <= 0) {
              this.siteList2 = res.data.siteList;
            }
          }
        });
    },
    changeSource(val) {
      this.searchParams.registrationUserList = [];
      if (val === 0) {
        this.getRegistrationUserList('');
      } else if (val === 1) {
        this.getRegistrationUserList2('');
      } else {
        this.registerList = [];
      }
    },
    getRegister(val) {
      if (this.searchParams.registrationSource === 0) {
        this.getRegistrationUserList(val);
      } else if (this.searchParams.registrationSource === 1) {
        this.getRegistrationUserList2(val);
      } else {
        this.registerList = [];
      }
    },
    // 服务商用户
    getRegistrationUserList2(val) {
      const data = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          code: '',
          username: val,
          orgId: '',
          accountState: -1,
          userState: -1,
          accountRole: -1
        }
      };
      getdelivererList(data).then(res => {
        if (res.code === 200) {
          this.registerList = res.data.records;
        }
      });
    },
    // 快递用户
    getRegistrationUserList(val) {
      const data = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '',
          username: val
        }
      };
      getUserPage(data).then((res) => {
        if (res.code === 200) {
          this.registerList = res.data.records;
          this.registrationList = res.data.records;
        }
      });
    },
    clickSearch() {
      this.$emit('child-search', this.searchParams);
      this.searchDrawer = false;
    },
    resetForm() {
      this.searchParams = {
        handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
        handlingRegionList: [], // 处理大区
        handlingSiteList: [], // 处理网点
        reportRegionList: [], // 上报大区
        reportSiteList: [], // 上报网点
        registrationUserList: [], // 登记人
        endOperationPersonList: [], // 结束操作人
        registrationSource: null
      };
      this.getRegion();
      this.getSiteList();
      this.getRegistrationUserList('');
      this.getRegistrationUserList2('');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
